import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
// import * as qs from "querystring";
// import Cookie from "js-cookie";
import MobileDetect from "mobile-detect";

import { unregister } from "./registerServiceWorker";
import App from "./components/App";
import Store from "./store";
import "./index.css";

unregister();

const store = new Store();

if (process.env.NODE_ENV === "development") {
  window.__STORE__ = store;
}

/*
if (
  window.location.href.indexOf("mosaic.podop.com") >= 0 &&
  !Cookie.get("dev")
) {
  if (qs.parse(window.location.search.replace("?", "")).dev) {
    Cookie.set("dev", "1");
  } else {
    window.location.href = "https://www.watchmosaic.com/";
  }
}
 */
 
const md = new MobileDetect(window.navigator.userAgent);
const isMobile = md.is("iOS") || md.is("AndroidOS");
if (process.env.NODE_ENV !== "development" && isMobile) {
  if (window.location.pathname !== "/") {
    window.location.pathname = "/";
  }
}

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if (isIE11) {
  document.body.classList.add("ie11");
}

ReactDOM.render(<App store={store} />, document.getElementById("root"));

const startApp = () => store.startApp();

// Facebook
window.fbAsyncInit = function() {
  const { FB } = window;

  FB.init({
    appId: process.env.REACT_APP_FACEBOOK_APP_ID,
    xfbml: true,
    version: "v2.10",
    cookie: true,
  });
  FB.AppEvents.logPageView();

  startApp();
};

window.fbAsyncException = () => {
  startApp();
};

if (process.env.REACT_APP_FACEBOOK_APP_ID !== "")
{
    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      js.onerror = window.fbAsyncException;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
}
else {
    startApp()
}

// Twitter
(function() {
  if (window.__twitterIntentHandler) return;
  var intentRegex = /twitter\.com\/intent\/(\w+)/,
    windowOptions = "scrollbars=yes,resizable=yes,toolbar=no,location=yes",
    width = 550,
    height = 420,
    winHeight = window.screen.height,
    winWidth = window.screen.width;

  function handleIntent(e) {
    e = e || window.event;
    var target = e.target || e.srcElement,
      m,
      left,
      top;

    while (target && target.nodeName.toLowerCase() !== "a") {
      target = target.parentNode;
    }

    if (target && target.nodeName.toLowerCase() === "a" && target.href) {
      m = target.href.match(intentRegex);
      if (m) {
        left = Math.round(winWidth / 2 - width / 2);
        top = 0;

        if (winHeight > height) {
          top = Math.round(winHeight / 2 - height / 2);
        }

        window.open(
          target.href,
          "intent",
          windowOptions +
            ",width=" +
            width +
            ",height=" +
            height +
            ",left=" +
            left +
            ",top=" +
            top
        );
        e.returnValue = false;
        e.preventDefault && e.preventDefault();
      }
    }
  }

  if (document.addEventListener) {
    document.addEventListener("click", handleIntent, false);
  } else if (document.attachEvent) {
    document.attachEvent("onclick", handleIntent);
  }
  window.__twitterIntentHandler = true;
})();



// WEBPACK FOOTER //
// ./src/index.js